(function () {
'use strict';
if (window.TiffyDiscountV2) return;
window.TiffyDiscountV2 = true;
var key = 'tiffy_discount_code';
var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
if (base.slice(-1) !== '/') base += '/';
var busy = false;
function saved() { try { return sessionStorage.getItem(key) || ''; } catch (_) { return ''; } }
function save(code) { try { sessionStorage.setItem(key, code); } catch (_) {} }
function money(cents) {
  var currency = (window.Shopify && window.Shopify.currency && (window.Shopify.currency.active || window.Shopify.currency.current)) || 'EUR';
  try { if(currency==='EUR') return '€'+new Intl.NumberFormat('de-DE',{minimumFractionDigits:2,maximumFractionDigits:2}).format(Number(cents || 0)/100); return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:currency}).format(Number(cents || 0)/100); }
  catch (_) { return (Number(cents || 0)/100).toFixed(2)+' '+currency; }
}
function state(root, value, isError) {
  var el = root.querySelector('[data-tiffy-code-status], [data-tiffy-discount-message]');
  if (!el) return;
  el.textContent = value;
  el.classList.toggle('is-error', !!isError);
  el.classList.toggle('is-success', !isError && !!value);
}
function prefill(code) {
  document.querySelectorAll('[data-tiffy-code-input], [data-tiffy-discount-input]').forEach(function(input) {
    if (document.activeElement !== input) input.value = code;
  });
}
function request(path, options) {
  return fetch(base+path, options).then(function(response) {
    if (!response.ok) return response.json().catch(function(){return {};}).then(function(body){throw new Error(body.description || body.message || 'Please try again.');});
    return response.json();
  });
}
function readCart(){return request('cart.js');}
function update(code){return request('cart/update.js',{method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({discount:code})});}
function findCode(cart, code) {
  var codes = cart.discount_codes || cart.discountCodes || [];
  return codes.find(function(d){return String(d.code || '').toLowerCase()===code.toLowerCase();});
}
function totals(cart) {
  document.querySelectorAll('[data-subtotal]').forEach(function(el){
    el.textContent=money(cart.total_price);
    el.classList.toggle('tiffy-price-discounted', Number(cart.total_price)<Number(cart.original_total_price));
  });
  syncCartLinePricing(cart);
}
function syncCartLinePricing(cart) {
  var items=cart.items || [];
  document.querySelectorAll('#CartDrawer .cart__item[data-key], #CartPageForm .cart__item[data-key]').forEach(function(row) {
    var item=items.find(function(i){return i.key===row.getAttribute('data-key');});
    if(!item)return;
    var original=Number(item.original_price), final=Number(item.final_price);
    if(!isFinite(original) || !isFinite(final) || original<=0)return;
    var col=row.querySelector('.cart__item-price-col');
    if(!col)return;
    var old=col.querySelector('.cart__price--strikethrough, .tiffy-cart-original');
    var now=col.querySelector('.cart__price.cart__discount, .tiffy-cart-final');
    var percent=col.querySelector('.tiffy-cart-percent');
    if(final<original) {
      if(!old) {
        old=document.createElement('small');old.className='cart__price cart__price--strikethrough tiffy-cart-original';
        col.insertBefore(old,now || col.firstChild);
      }
      if(!now) {
        now=document.createElement('span');now.className='cart__price cart__discount tiffy-cart-final';
        old.insertAdjacentElement('afterend',now);
      }
      if(!percent) {
        percent=document.createElement('span');percent.className='tiffy-cart-percent';
        now.parentNode.insertBefore(percent,now);
      }
      old.classList.remove('tpo_cart_item_price');
      now.classList.remove('tpo_cart_item_price');
      if(old.textContent.trim()!==money(original))old.textContent=money(original);
      if(now.textContent.trim()!==money(final))now.textContent=money(final);
      var pct='−'+Math.round((original-final)*100/original)+'%';
      if(percent.textContent!==pct)percent.textContent=pct;
    } else {
      if(percent)percent.remove();
      if(old && old.classList.contains('tiffy-cart-original'))old.remove();
      if(now) {
        now.classList.remove('tiffy-price-discounted');
        if(now.textContent.trim()!==money(final))now.textContent=money(final);
      }
    }
  });
}
function watchDrawerPricing() {
  var targets=document.querySelectorAll('#CartDrawer [data-products], #CartPageForm [data-products]');
  if(!targets.length || typeof MutationObserver==='undefined')return;
  var scheduled=false;
  var observer=new MutationObserver(function(){
    if(scheduled)return;scheduled=true;
    window.setTimeout(function(){
      scheduled=false;
      readCart().then(function(cart){totals(cart);}).catch(function(){});
    },90);
  });
  targets.forEach(function(el){observer.observe(el,{subtree:true,childList:true,characterData:true});});
}
function showProductPrice(root, item) {
  var section=root.closest('[data-product-id]') || root.closest('.product-section') || root.closest('product-hot-reload');
  var el=section && section.querySelector('[data-product-price]');
  if(!el) {
    el=root.querySelector('[data-tiffy-product-price-preview]');
    if(!el) {
      el=document.createElement('div');
      el.setAttribute('data-tiffy-product-price-preview','');
      el.style.marginTop='8px';
      root.appendChild(el);
    }
  }
  el.textContent='';
  var old=document.createElement('del');old.className='tiffy-price-original';old.textContent=money(item.original_price);
  var now=document.createElement('strong');now.className='tiffy-price-discounted';now.textContent=money(item.final_price);
  el.appendChild(old);el.appendChild(now);
}
function productApply(root, code) {
  var section=root.closest('[data-product-id]') || root.closest('.product-section') || root.closest('product-hot-reload');
  var form=(section && section.querySelector('form.product-single__form, product-form form')) || root.closest('form');
  if(!form) throw new Error('Please select the product size first.');
  var addButton=form.querySelector('[data-add-to-cart]');
  if(addButton && addButton.disabled) throw new Error('This size is unavailable.');
  var data=new FormData(form), variant=Number(data.get('id'));
  if(!variant) throw new Error('Please select a size first.');
  return readCart().then(function(before){
    var exists=(before.items || []).some(function(item){return Number(item.variant_id)===variant;});
    if(exists) return null;
    return request('cart/add.js',{method:'POST',body:data});
  }).then(function(){return update(code);}).then(function(cart){
    var discount=findCode(cart,code);
    if(!discount || discount.applicable===false) throw new Error('This code is not valid for the selected product.');
    var item=(cart.items || []).find(function(item){return Number(item.variant_id)===variant && Number(item.final_price)<Number(item.original_price);});
    if(!item) throw new Error('This code does not reduce this product price.');
    totals(cart);showProductPrice(root,item);
    state(root,'Discount applied. Item added to cart; your code stays active through checkout.',false);
  });
}
function cartOrHomeApply(root,code){
  return readCart().then(function(before){return update(code).then(function(after){
    if(!before.item_count){state(root,'Code saved. Add an eligible product to see the discounted price.',false);return;}
    var discount=findCode(after,code);
    if(!discount || discount.applicable===false) throw new Error('This code is not valid for the items in your cart.');
    totals(after);
    var saving=Math.max(0,Number(after.original_total_price || 0)-Number(after.total_price || 0));
    state(root,'Discount applied. You save '+money(saving)+'. The code stays active through checkout.',false);
  });});
}
function run(root) {
  if(!root || busy)return;
  var input=root.querySelector('[data-tiffy-code-input], [data-tiffy-discount-input]');
  var button=root.querySelector('[data-tiffy-code-apply], [data-tiffy-discount-apply]');
  var code=input && input.value.trim();
  if(!code){state(root,'Please enter a discount code.',true);return;}
  busy=true;if(button){button.disabled=true;button.textContent='APPLYING…';}state(root,'',false);
  Promise.resolve().then(function(){
    return root.dataset.tiffyContext==='product' ? productApply(root,code) : cartOrHomeApply(root,code);
  }).then(function(){save(code);prefill(code);}).catch(function(error){state(root,error.message || 'Please check your code.',true);}).finally(function(){
    busy=false;if(button){button.disabled=false;button.textContent='APPLY';}
  });
}
document.addEventListener('click',function(event){
  var button=event.target.closest('[data-tiffy-code-apply], [data-tiffy-discount-apply]');
  if(!button)return;
  event.preventDefault();event.stopPropagation();
  run(button.closest('[data-tiffy-discount-widget], [data-tiffy-discount]'));
},true);
document.addEventListener('keydown',function(event){
  if(event.key!=='Enter' || !event.target.matches('[data-tiffy-code-input], [data-tiffy-discount-input]'))return;
  event.preventDefault();run(event.target.closest('[data-tiffy-discount-widget], [data-tiffy-discount]'));
},true);
document.addEventListener('change',function(event){
  if(!event.target.matches('[data-product-select], input[type="radio"]'))return;
  var section=event.target.closest('[data-product-id]');
  var widget=section && section.querySelector('[data-tiffy-discount-widget][data-tiffy-context="product"]');
  if(widget)state(widget,'Selection changed. Press Apply to verify the new price.',false);
},true);
function init(){
  watchDrawerPricing();
  var code=saved();
  if(!code)readCart().then(totals).catch(function(){});
  if(code) {
    prefill(code);
    readCart().then(function(cart){
      if(cart.item_count && !findCode(cart,code)) return update(code).then(totals);
      totals(cart);
    }).catch(function(){});
  }
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();